import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid'; // Para generar nombres de archivos únicos
import { post } from '../../services/back.service';
import { Alert, Spinner, Form, Button, Container } from '@themesberg/react-bootstrap';

function FileUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false); // Estado para controlar la carga
  const [process, setProcess] = useState([]); // Estado para controlar la carga

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const uploadToS3 = async (file, uploadUrl) => {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to upload to S3: ${response.statusText}`);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile || uploading) { // Evita cargar si ya se está cargando un archivo
      return;
    }

    setUploading(true); // Inicia la carga
    const fileKey = `${uuidv4()}.xlsx`; // Genera un nombre de archivo único

    const body = {
      "bucket": "csv-data-peritaje",
      "object_name": fileKey,
      "content_type": selectedFile.type
    }
    const url_response = await post('/catalog/signed-upload-url/', body)

    try {
      await uploadToS3(selectedFile, url_response.data.url);
      setProcess((prevprocess) => [...prevprocess, { type: 'success', msg: 'Archivo cargado con éxito' }])
      const valid = await post('/catalog/uploadfile/', { "name": fileKey })
      if (valid.success) {
        setProcess((prevprocess) => [...prevprocess, { type: 'success', msg: 'Archivo procesado con éxito' }])
        setProcess((prevprocess) => [...prevprocess, { type: 'success', msg: `Registros Cargados ${valid.data.count} de ${valid.data.total}` }])
      } else {
        setProcess((prevprocess) => [...prevprocess, { type: 'danger', msg: valid.message }])
      }
    } catch (error) {
      console.error('Error al cargar el archivo a S3:', error);
      setProcess((prevprocess) => [...prevprocess, { type: 'danger', msg: 'Error al cargar el archivo' }])
    } finally {
      setUploading(false); // Finaliza la carga
    }
  };

  return (
    <Container className='mt-4'>
      <Form.Control type="file" onChange={handleFileChange} />
      {uploading
        ? <Spinner className='m-2' animation="border" role="status" variant="danger"><span className="visually-hidden">Loading...</span></Spinner>
        : <Button className='m-2' onClick={handleUpload}>Cargar archivo</Button>
      }
      {
        process.map((element, i) => {
          return <Alert key={i} variant={element.type}>{element.msg}</Alert>
        })
      }
    </Container>
  );
}

export default FileUpload;
